import React from 'react';
const links = ['Regulamin', 'Polityka Prywatności', 'Polityka Zwrotów', 'Kontakt'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-99" data-mp="3ggtx2ezk5d3n">
      <div className="mx-auto max-w-5xl text-center" data-id="element-100" data-mp="32o48q3wk3w3d">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-101" data-mp="32pp57z2flp3v">
          MUZYKA GOTOWA™
        </p>
        <nav aria-label="Stopka" data-id="element-102" data-mp="3uf0obca04euc">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-103" data-mp="3ues8bbil0tex">
            {links.map(link => <li key={link} data-id="element-104" data-mp="3lecb2jsfmiii">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-105" data-mp="3lf56wppurnlv">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-106" data-mp="2a1jjb8zn5u2g">
          © 2026 MUZYKA GOTOWA™ by EduLabs Polska — Wszelkie prawa zastrzeżone.
        </p>
      </div>
    </footer>;
}